/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Discounts from './Discounts/index'
import Expandable from './Expandable/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/Treatment/Discounts/Content"
  
}) {
  return (<React.Fragment
>
<Discounts
  viewPath={`${viewPath}/Discounts`}
/>
<Expandable
  viewPath={`${viewPath}/Expandable`}
/>
{children}
</React.Fragment>)
}